export const actions = {
  FECHA_NO_ENTREGA_LOAD_REQUESTED: 'FECHA_NO_ENTREGA_LOAD_REQUESTED',
  FECHA_NO_ENTREGA_LOAD_SUCCEEDED: 'FECHA_NO_ENTREGA_LOAD_SUCCEEDED',
  FECHA_NO_ENTREGA_LOAD_FILED: 'FECHA_NO_ENTREGA_LOAD_FILED',

  FECHA_NO_ENTREGA_BY_ID_LOAD_REQUESTED: 'FECHA_NO_ENTREGA_BY_ID_LOAD_REQUESTED',
  FECHA_NO_ENTREGA_BY_ID_LOAD_SUCCEEDED: 'FECHA_NO_ENTREGA_BY_ID_LOAD_SUCCEEDED',
  FECHA_NO_ENTREGA_BY_ID_LOAD_FILED: 'FECHA_NO_ENTREGA_BY_ID_LOAD_FILED',

  FECHA_NO_ENTREGA_INSERT_REQUESTED: 'FECHA_NO_ENTREGA_INSERT_REQUESTED',
  FECHA_NO_ENTREGA_INSERT_SUCCEEDED: 'FECHA_NO_ENTREGA_INSERT_SUCCEEDED',
  FECHA_NO_ENTREGA_INSERT_FILED: 'FECHA_NO_ENTREGA_INSERT_FILED',

  FECHA_NO_ENTREGA_UPDATE_REQUESTED: 'FECHA_NO_ENTREGA_UPDATE_REQUESTED',
  FECHA_NO_ENTREGA_UPDATE_SUCCEEDED: 'FECHA_NO_ENTREGA_UPDATE_SUCCEEDED',
  FECHA_NO_ENTREGA_UPDATE_FILED: 'FECHA_NO_ENTREGA_UPDATE_FILED',

  FECHA_NO_ENTREGA_DELETE_REQUESTED: 'FECHA_NO_ENTREGA_DELETE_REQUESTED',
  FECHA_NO_ENTREGA_DELETE_SUCCEEDED: 'FECHA_NO_ENTREGA_DELETE_SUCCEEDED',
  FECHA_NO_ENTREGA_DELETE_FILED: 'FECHA_NO_ENTREGA_DELETE_FILED',

  FECHA_NO_ENTREGA_PROVINCIA_LOAD_REQUESTED: 'FECHA_NO_ENTREGA_PROVINCIA_LOAD_REQUESTED',
  FECHA_NO_ENTREGA_PROVINCIA_LOAD_SUCCEEDED: 'FECHA_NO_ENTREGA_PROVINCIA_LOAD_SUCCEEDED',
  FECHA_NO_ENTREGA_PROVINCIA_LOAD_FILED: 'FECHA_NO_ENTREGA_PROVINCIA_LOAD_FILED',

  FECHA_NO_ENTREGA_PROVINCIA_UPDATE_REQUESTED: 'FECHA_NO_ENTREGA_PROVINCIA_UPDATE_REQUESTED',
  FECHA_NO_ENTREGA_PROVINCIA_UPDATE_SUCCEEDED: 'FECHA_NO_ENTREGA_PROVINCIA_UPDATE_SUCCEEDED',
  FECHA_NO_ENTREGA_PROVINCIA_UPDATE_FILED: 'FECHA_NO_ENTREGA_PROVINCIA_UPDATE_FILED',

  FECHA_NO_ENTREGA_PROVINCIA_DELETE_REQUESTED: 'FECHA_NO_ENTREGA_PROVINCIA_DELETE_REQUESTED',
  FECHA_NO_ENTREGA_PROVINCIA_DELETE_SUCCEEDED: 'FECHA_NO_ENTREGA_PROVINCIA_DELETE_SUCCEEDED',
  FECHA_NO_ENTREGA_PROVINCIA_DELETE_FILED: 'FECHA_NO_ENTREGA_PROVINCIA_DELETE_FILED',

  FECHA_NO_ENTREGA_CATEGORIA_PERSO_LOAD_REQUESTED:
    'FECHA_NO_ENTREGA_CATEGORIA_PERSO_LOAD_REQUESTED',
  FECHA_NO_ENTREGA_CATEGORIA_PERSO_LOAD_SUCCEEDED:
    'FECHA_NO_ENTREGA_CATEGORIA_PERSO_LOAD_SUCCEEDED',
  FECHA_NO_ENTREGA_CATEGORIA_PERSO_LOAD_FILED: 'FECHA_NO_ENTREGA_CATEGORIA_PERSO_LOAD_FILED',

  FECHA_NO_ENTREGA_CATEGORIA_PERSO_UPDATE_REQUESTED:
    'FECHA_NO_ENTREGA_CATEGORIA_PERSO_UPDATE_REQUESTED',
  FECHA_NO_ENTREGA_CATEGORIA_PERSO_UPDATE_SUCCEEDED:
    'FECHA_NO_ENTREGA_CATEGORIA_PERSO_UPDATE_SUCCEEDED',
  FECHA_NO_ENTREGA_CATEGORIA_PERSO_UPDATE_FILED: 'FECHA_NO_ENTREGA_CATEGORIA_PERSO_UPDATE_FILED',

  FECHA_NO_ENTREGA_CATEGORIA_PERSO_DELETE_REQUESTED:
    'FECHA_NO_ENTREGA_CATEGORIA_PERSO_DELETE_REQUESTED',
  FECHA_NO_ENTREGA_CATEGORIA_PERSO_DELETE_SUCCEEDED:
    'FECHA_NO_ENTREGA_CATEGORIA_PERSO_DELETE_SUCCEEDED',
  FECHA_NO_ENTREGA_CATEGORIA_PERSO_DELETE_FILED: 'FECHA_NO_ENTREGA_CATEGORIA_PERSO_DELETE_FILED',

  FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_LOAD_REQUESTED:
    'FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_LOAD_REQUESTED',
  FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_LOAD_SUCCEEDED:
    'FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_LOAD_SUCCEEDED',
  FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_LOAD_FILED:
    'FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_LOAD_FILED',

  FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_DELETE_REQUESTED:
    'FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_DELETE_REQUESTED',
  FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_DELETE_SUCCEEDED:
    'FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_DELETE_SUCCEEDED',
  FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_DELETE_FILED:
    'FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_DELETE_FILED',

  FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_UPDATE_REQUESTED:
    'FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_UPDATE_REQUESTED',
  FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_UPDATE_SUCCEEDED:
    'FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_UPDATE_SUCCEEDED',
  FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_UPDATE_FILED:
    'FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_UPDATE_FILED',

  FECHA_NO_ENTREGA_DIAS_LOAD_REQUESTED: 'FECHA_NO_ENTREGA_DIAS_LOAD_REQUESTED',
  FECHA_NO_ENTREGA_DIAS_LOAD_SUCCEEDED: 'FECHA_NO_ENTREGA_DIAS_LOAD_SUCCEEDED',
  FECHA_NO_ENTREGA_DIAS_LOAD_FILED: 'FECHA_NO_ENTREGA_DIAS_LOAD_FILED',

  FECHA_NO_ENTREGA_DIA_UPDATE_REQUESTED: 'FECHA_NO_ENTREGA_DIA_UPDATE_REQUESTED',
  FECHA_NO_ENTREGA_DIA_UPDATE_SUCCEEDED: 'FECHA_NO_ENTREGA_DIA_UPDATE_SUCCEEDED',
  FECHA_NO_ENTREGA_DIA_UPDATE_FILED: 'FECHA_NO_ENTREGA_DIA_UPDATE_FILED',

  FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_LOAD_REQUESTED:
    'FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_LOAD_REQUESTED',
  FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_LOAD_SUCCEEDED:
    'FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_LOAD_SUCCEEDED',
  FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_LOAD_FILED:
    'FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_LOAD_FILED',

  FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_UPDATE_REQUESTED:
    'FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_UPDATE_REQUESTED',
  FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_UPDATE_SUCCEEDED:
    'FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_UPDATE_SUCCEEDED',
  FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_UPDATE_FILED:
    'FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_UPDATE_FILED',
}

export const getFechasNoEntregaAction = dispatch => {
  dispatch({
    type: actions.FECHA_NO_ENTREGA_LOAD_REQUESTED,
  })
}

export const getFechaNoEntregaAction = (dispatch, id) => {
  dispatch({
    type: actions.FECHA_NO_ENTREGA_BY_ID_LOAD_REQUESTED,
    payload: id,
  })
}

export const onSubmitFechaNoEntregaAction = (dispatch, fechaNoEntregaForm) => {
  dispatch({
    type: actions.FECHA_NO_ENTREGA_INSERT_REQUESTED,
    payload: fechaNoEntregaForm,
  })
}

export const onSubmitFechaNoEntregaUpdateAction = (dispatch, fechaNoEntregaForm) => {
  dispatch({
    type: actions.FECHA_NO_ENTREGA_UPDATE_REQUESTED,
    payload: fechaNoEntregaForm,
  })
}

export const deleteFechaNoEntregaAction = (dispatch, id) => {
  dispatch({
    type: actions.FECHA_NO_ENTREGA_DELETE_REQUESTED,
    payload: id,
  })
}

export const getFechaNoEntregaProvinciasAction = (dispatch, fechaId) => {
  dispatch({
    type: actions.FECHA_NO_ENTREGA_PROVINCIA_LOAD_REQUESTED,
    payload: fechaId,
  })
}

export const onSubmitFechaNoEntregaProvinciaUpdateAction = (
  dispatch,
  fechaNoEntregaProvinciaForm,
) => {
  dispatch({
    type: actions.FECHA_NO_ENTREGA_PROVINCIA_UPDATE_REQUESTED,
    payload: fechaNoEntregaProvinciaForm,
  })
}

export const deleteFechasNoEntregaProvinciasAction = (dispatch, fechaId) => {
  dispatch({
    type: actions.FECHA_NO_ENTREGA_PROVINCIA_DELETE_REQUESTED,
    payload: fechaId,
  })
}

export const getFechaNoEntregaCategoriaPersoAction = (dispatch, fechaId) => {
  dispatch({
    type: actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_LOAD_REQUESTED,
    payload: fechaId,
  })
}

export const onSubmitFechaNoEntregaCategoriaPersoUpdateAction = (
  dispatch,
  fechaNoEntregaCategoriaPersoForm,
) => {
  dispatch({
    type: actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_UPDATE_REQUESTED,
    payload: fechaNoEntregaCategoriaPersoForm,
  })
}

export const deleteFechaNoEntregaCategoriaPersoAction = (
  dispatch,
  fechaNoEntregaCategoriaPersoForm,
) => {
  dispatch({
    type: actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DELETE_REQUESTED,
    payload: fechaNoEntregaCategoriaPersoForm,
  })
}

export const getCategoriasPersoDiaAction = (dispatch, diaId) => {
  dispatch({
    type: actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_LOAD_REQUESTED,
    payload: diaId,
  })
}

export const deleteCategoriasPersoDiaAction = (dispatch, diaId) => {
  dispatch({
    type: actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_DELETE_REQUESTED,
    payload: diaId,
  })
}

export const onSubmitCategoriasPersoDiaUpdateAction = (dispatch, categoriasPersoDiaForm) => {
  dispatch({
    type: actions.FECHA_NO_ENTREGA_CATEGORIA_PERSO_DIA_UPDATE_REQUESTED,
    payload: categoriasPersoDiaForm,
  })
}

export const getDiasAction = dispatch => {
  dispatch({
    type: actions.FECHA_NO_ENTREGA_DIAS_LOAD_REQUESTED,
  })
}

export const onSubmitDiaUpdateFormAction = (dispatch, diaForm) => {
  dispatch({
    type: actions.FECHA_NO_ENTREGA_DIA_UPDATE_REQUESTED,
    payload: diaForm,
  })
}

export const getActivarCorteAction = (dispatch, id) => {
  dispatch({
    type: actions.FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_LOAD_REQUESTED,
    payload: id,
  })
}

export const onSubmiActivarCorteUpdateFormAction = (dispatch, activarCorteForm) => {
  dispatch({
    type: actions.FECHA_NO_ENTREGA_CONFIGURACION_CATEGORIA_UPDATE_REQUESTED,
    payload: activarCorteForm,
  })
}
